// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { deliveryInventoryMessageStyles } from "@bg/App/Components/OnePageCheckout/DeliveryInventoryMessage";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { css } from "styled-components";

deliveryInventoryMessageStyles.container = {
    css: css`
        width: 100%;
        display: block;
        margin-top: 16px;
    `,
};

deliveryInventoryMessageStyles.message = {
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    css: css`
        display: flex;
        align-items: flex-start;
    `,
};

deliveryInventoryMessageStyles.icon = {
    src: "ReportProblem",
    size: 16,
    color: "warning",
    css: css`
        margin-right: 3px;
    `,
};
